import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ServerVariableService {



  NO_CUSTOMERS_FOUND = 'No Customer found.'
  NO_STAFF_FOUND = 'No Staff found.'
  NO_ATTENDANCE_FOUND = 'No Attendance found.'
  NO_MACHINE_FOUND = 'No Machine found.'
  NO_RECORD_FOUND = 'No Records found.'
  NO_SERVICE_REQUESTS_FOUND = 'No Service Request found.'
  NO_TRIPS_FOUND = 'No Trips found.'
  NO_SERVICE_FOUND = 'No Service Found.'

  PATH_FOR_API = 'api/';
  PATH_FOR_W_O_TOKEN = 'woToken/';
  PATH_FOR_TEST = 'test/';

  USER_OF_LOCAL_STORAGE = 'user';


  LOGIN_API = this.PATH_FOR_API + 'login';
  LOGOUT_API = this.PATH_FOR_API + 'log_out';


  MASTER_ALL_DATA = this.PATH_FOR_API + 'master/alldata'
  MASTER_ADD_DATA = this.PATH_FOR_API + 'master/store'
  MASTER_UPDATE_DATA = this.PATH_FOR_API + 'master/update'
  MASTER_DELETE_DATA = this.PATH_FOR_API + 'master/destroy'

  REGISTER_CUSTOMER_API = this.PATH_FOR_API + 'register';
  // CUSTOMERS_API = this.PATH_FOR_API + 'customerList';
  CUSTOMERS_API = this.PATH_FOR_API + 'customerListPage';
  EDIT_USER_API = this.PATH_FOR_API + 'editUser';
  GET_USER_API = this.PATH_FOR_API + 'getUser';
  GET_ALL_CUSTOMERS_API = this.PATH_FOR_API + 'AllcustomerListing';

  ADD_MACHINE_API = this.PATH_FOR_API + 'machine/store';
  GET_MACHINE_API = this.PATH_FOR_API + 'machine/singleRecord';
  GET_DROPDOWN_DATA_FOR_MACHINE_API = this.PATH_FOR_API + 'machine/machineData';
  UPDATE_MACHINE_API = this.PATH_FOR_API + 'machine/update';
  UPDATE_IMAGE_API = this.PATH_FOR_API + 'machine/image/update'
  UPDATE_AMC_API = this.PATH_FOR_API + 'machine/updateAMC';
  MACHINE_DELETE_API = this.PATH_FOR_API + 'machine/destroy';


  STAFF_REQ_LIST_API = this.PATH_FOR_API + 'list_request_offices'
  STAFF_LIST_API = this.PATH_FOR_API + 'staffList';
  STAFF_DELETE_API = this.PATH_FOR_API + 'deleteStaff';
  STAFF_CHANGE_PASSWORD_API = this.PATH_FOR_API + 'changeStaffPassword';

  ATTENDANCE_LIST_API = this.PATH_FOR_API + 'attendance';
  // ATTENDANCE_RANGE_LIST_API = this.PATH_FOR_API + 'attendance_range';
  ATTENDANCE_RANGE_LIST_API = this.PATH_FOR_API + 'attendance_range_page';
  ATTENDANCE_SIGN_OUT = this.PATH_FOR_API + 'admin_staff_signout'

  GET_CUSTOMER_SERVICES_API = this.PATH_FOR_API + 'service/customerServices';
  // GET_ALL_SERVICES_API = this.PATH_FOR_API + 'service/allServices';
  GET_ALL_SERVICES_API = this.PATH_FOR_API + 'service/allServicesPage';
  GET_DROP_DOWN_DATA_FOR_SERVICE_API = this.PATH_FOR_API + 'service/serviceData';
  GET_MACHINES_BY_CUSTOMER_API = this.PATH_FOR_API + 'service/machines';
  ADD_SERVICE_API = this.PATH_FOR_API + 'service/store';
  UPDATE_SERVICE_API = this.PATH_FOR_API + 'service/update';
  GET_ATTENDANT_USERS_API = this.PATH_FOR_API + 'service/attendantUser';
  UPDATE_SERVICE_STATUS_API = this.PATH_FOR_API + 'service/updateServicestatus';
  SCHEDULE_DATE_API = this.PATH_FOR_API + 'service/scheduleDate';

  REOPEN_SERVICE_API = this.PATH_FOR_API + 'service/reopen';
  PARENT_SERVICE_API = this.PATH_FOR_API + 'service/parent_service'

  ADMIN_START_WORK_API = this.PATH_FOR_API + 'adminstartWork';
  ADMIN_END_WORK_API = this.PATH_FOR_API + 'adminendWork';
  GET_ORDER_LIST_API = this.PATH_FOR_API + 'sales/order/saleList';
  UPDATE_SALE_ORDER_STATUS_API = this.PATH_FOR_API + 'sales/order/updateStatus';
  UPDATE_MACHINE_STATUS_API = this.PATH_FOR_API + 'sales/order/updateMachineStatus';
  GET_SALE_COUNTERS_API = this.PATH_FOR_API + 'sales/order/saleCounter';

  GET_NOTIFICATION_API = this.PATH_FOR_API + 'getnotification';

  //Trips
  GET_TRIP_STAFF_LIST = this.PATH_FOR_API + 'trip_staff_list';
  GET_STAFF_TRIP_DETAILS = this.PATH_FOR_API + 'single_staff_trips_v2';

  GET_MONTHLY_LIST_REPORT = this.PATH_FOR_API + 'monthly_report'
  GET_MONTHLY_DETAILS = this.PATH_FOR_API + 'monthly_report_detail'
  GET_STAFF_LOCATION = this.PATH_FOR_API + 'send_location_notification'
  UPDATE_REQ_OFFICE = this.PATH_FOR_API + 'update_request_offices';
  DELETE_SALES_ORDER_API = this.PATH_FOR_API + 'sales/order/delete';


  //  Sales Order
  GET_CUSTOMER_LIST_FOR_SALES_ORDER_API = this.PATH_FOR_API + 'sales/order/customerList';
  CREATE_OR_EDIT_SALES_ORDER_API = this.PATH_FOR_API + 'sales/order/createOrEdit';
  GET_SALES_ORDER_BY_ID_API = this.PATH_FOR_API + 'sales/order/getSale';
  SET_SALES_ORDER_SETTINGS_API = this.PATH_FOR_API + 'sales/order/setSetting';
  GET_SALES_ORDER_SETTINGS_API = this.PATH_FOR_API + 'sales/order/getSetting';
  GET_REMINDERS_LIST_BY_SALES_ID_API = this.PATH_FOR_API + 'sales/order/saleReminderList';
  UPDATE_SALES_ORDER_REMINDER_API = this.PATH_FOR_API + 'sales/order/updateReminder';
  GET_REMINDER_LIST_API = this.PATH_FOR_API + 'sales/order/reminderList';
  GET_REMINDER_DROPDOWN_DATA_API = this.PATH_FOR_API + 'sales/order/reminderFilterDropdown';
  GET_REMINDER_NOTES_API = this.PATH_FOR_API + 'sales/order/listReminderNote';
  UPDATE_REMINDER_NOTE_API = this.PATH_FOR_API + 'sales/order/storeOrUpdateReminderNote';
  STORE_REMINDER_API = this.PATH_FOR_API + 'sales/order/storeReminder';
  DELETE_REMINDER_NOTE_API = this.PATH_FOR_API + 'sales/order/deleteReminderNote';
  CREATE_FIRM_API = this.PATH_FOR_API + 'sales/order/createFirm';
  GET_MACHINE_LIST_BY_SALES_ORDER_API = this.PATH_FOR_API + 'sales/order/getMachineListBySale';

  RECORD_PAYMENT_API = this.PATH_FOR_API + 'sales/order/recordPayment';
  UPDATE_MACHINE_ORDER_DATE_API = this.PATH_FOR_API + 'sales/order/updateMachineOrderDate';
  CANCEL_MACHINE_API = this.PATH_FOR_API + 'sales/order/cancelMachineById';
  GET_CANCEL_MACHINE_LIST_API = this.PATH_FOR_API + 'sales/order/stockMachineList';
  SAVE_ASSIGN_MACHINE_API = this.PATH_FOR_API + 'sales/order/formMachineAssignments';
  GET_FORM_NUMBER_DROPDOWN_LIST_API = this.PATH_FOR_API + 'sales/order/formNumberDropdownList';
  DELETE_PAYMENT_HISTORY_API = this.PATH_FOR_API + 'sales/order/deletePaymentHistory';
  COMPLETE_REMINDER_API = this.PATH_FOR_API + 'sales/order/reminderCompleted';
  GET_USER_DETAILS_BY_MOBILE_API = this.PATH_FOR_API + 'sales/order/filterCustomerMobileNumber';
  ADD_NEW_SALES_PERSON_API = this.PATH_FOR_API + 'sales/order/createSalesPerson';
  GET_SALES_PERSON_LIST_API = this.PATH_FOR_API + 'sales/order/getSalesPersons';
  CHECK_SALES_PERSON_IS_NEW_API = this.PATH_FOR_API + 'sales/order/checkOrderSalesPersons';
  GET_MACHINE_REPORT_LIST_API = this.PATH_FOR_API + 'sales/order/orderMachineReports';
  GET_ORDER_LOG_LIST_API = this.PATH_FOR_API + 'sales/order/getSaleStatusLogsBySale';
  APPROVE_CHANGES_API = this.PATH_FOR_API + 'sales/order/approveOrderChanges';
  SEND_SALES_ORDER_PDF_API = this.PATH_FOR_API + 'sales/order/sendPDFToCustomer';
  GET_MACHINE_PLACED_LIST_API = this.PATH_FOR_API + 'sales/order/orderMachineExcelReports';
  GET_SALES_ORDER_PDF_API = this.PATH_FOR_API + 'orders/pdfBuffer/';
  GET_UPDATE_ORDER_NOTE_LIST_API = this.PATH_FOR_API + 'sales/order/listOrderUpdateNotes';

  GET_ALL_FORM_NUMBERS_API = this.PATH_FOR_API + 'sales/order/getAllFormNumbers';

  GET_CUSTOMERS_API = this.PATH_FOR_API + 'sales/order/getCustomers';
  GET_SALES_ORDERS_BY_CUSTOMER_API = this.PATH_FOR_API + 'sales/order/getOrdersByCustomer';
  CHANGE_MACHINE_STATUS_API = this.PATH_FOR_API + 'sales/order/rollbackOrdersByMachine';
  DELETE_MACHINE_FROM_OUR_STOCK_API = this.PATH_FOR_API + 'sales/order/deleteMachineFromOurStock';
  ADD_NEW_MACHINE_TO_OUR_STOCK = this.PATH_FOR_API + 'sales/order/addNewMachineToOurStock';
  REMOVE_SALE_FROM_OVER_DUE = this.PATH_FOR_API + 'sales/order/removeSaleFromOverDue';
  ASSIGN_MACHINE_TO_SALE = this.PATH_FOR_API + 'sales/order/assignMachineToSale';
  SWAP_MACHINE_API = this.PATH_FOR_API + 'sales/order/autoSwapMachines';
  GET_SALES_PERSONS = this.PATH_FOR_API + 'sales/order/getSalesPersons'
  FETCH_SALES_PERSON = this.PATH_FOR_API + 'sales/order/fetchSalePersonReport'
  GET_SALE_MACHINE_LIST = this.PATH_FOR_API + 'sales/order/getSaleMachineList'
}
